import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import HowWork from '../../../assets/fn-how-work/how_work.png'
import { useTranslation } from 'react-i18next'

export const SMAppHowWork: React.FC = () => {
    const { t } = useTranslation()

    const data = [
        {
            'number': '01',
            'title': t('t43'),
            'content': t('t44')
        },
        {
            'number': '02',
            'title': t('t45'),
            'content': t('t46')
        },
        {
            'number': '03',
            'title': t('t47'),
            'content': t('t48')
        },
        {
            'number': '04',
            'title': t('t49'),
            'content': t('t50')
        },
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '20px'
            }}>
                <Box width={56} height={56} sx={{
                    border: '1px solid #FBBF23',
                    borderRadius: '28px',
                    alignContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography color={'#141F39'} fontSize={14} fontWeight={600} textAlign={'center'}>
                        {data[index]['number']}
                    </Typography>
                </Box>
                <Box sx={{
                    flex: '1',
                    paddingLeft: '14px'
                }}>
                    <Typography color={'#141F39'} fontSize={16} fontWeight={600} textAlign={'left'}>
                        {data[index]['title']}
                    </Typography>

                    <Typography color={'#6B6B6B'} fontSize={14} fontWeight={400} textAlign={'left'}>
                        {data[index]['content']}
                    </Typography>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#FFFFFF'
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                paddingTop: '60px',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingBottom: '20px',
                backgroundColor: '#FFFFFF'
            }}>
                <Image src={HowWork} style={{borderRadius: '10px'}} alt='' preview={false}></Image>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'start',
                    flexDirection: 'column',
                    paddingTop: '20px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    <Typography color={'#141F39'} fontSize={24} fontWeight={700} textAlign={'left'}>
                        {t('t41')}
                    </Typography>

                    <Typography color={'#141F39'} fontSize={16} fontWeight={400} textAlign={'left'} paddingBottom={'20px'}>
                        {t('t42')}
                    </Typography>

                    {data.map((item, index) => (
                        renderItem(index)
                    ))}

                </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMAppHowWork
